import React from 'react';
import { useSelector } from 'react-redux';
import RainbowContainer from '@clearscore/rainbow.container';
import Icon from '@clearscore/rainbow.icons.padlock';
import Text from '@clearscore/rainbow.text';
import withVertical from '@shared/webapp-vertical';

import getShowResetPasswordConfirmation from './lib/redux/selectors';
import language from './lib/lang';
import reducer from './lib/reducer';
import epics from './lib/epics';
import ResetPasswordForm from './components/reset-password-form';
import ResetPasswordConfirmation from './components/reset-password-confirmation';
import style from './reset-password.css';

const ResetPassword = () => {
    const showResetPasswordConfirmation = useSelector(getShowResetPasswordConfirmation);
    return (
        <RainbowContainer size={RainbowContainer.sizes.SMALL}>
            <div className={style.formWrapper}>
                <Text.H1>{!showResetPasswordConfirmation ? language.mainTitle : language.confirmationTitle}</Text.H1>
                {!showResetPasswordConfirmation ? (
                    <ResetPasswordForm />
                ) : (
                    <ResetPasswordConfirmation language={language} />
                )}
                <div className={style.security} data-qa="security-message">
                    <Icon width={12} height={12} />
                    <Text.Body2>{language.securityMessage}</Text.Body2>
                </div>
            </div>
        </RainbowContainer>
    );
};

export default withVertical(ResetPassword, {
    name: 'reset-password',
    reducer,
    epics,
});
